import { Button } from '@heroui/react';
import { useUI } from '@/contexts/UIContext';
import { SearchBar } from '@/layouts/shell/SearchBar';
import { NotificationBell } from '@/layouts/shell/NotificationBell';
import { ProfileMenu } from '@/layouts/shell/ProfileMenu';
import { TenantSwitcher } from '@/layouts/shell/TenantSwitcher';
import { ThemeToggle } from '@/components/ui/ThemeToggle';
import { Bars3Icon } from '@/icons';

/**
 * Top navigation bar: mobile hamburger, tenant switcher, search/command-palette
 * trigger, and the right-hand cluster (notifications, theme, account).
 */
export function TopBar() {
  const { setMobileNavOpen } = useUI();

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-border bg-surface/80 px-4 backdrop-blur">
      <Button
        isIconOnly variant="light" size="sm" className="lg:hidden text-fg-muted"
        aria-label="Open navigation menu" onPress={() => setMobileNavOpen(true)}
      >
        <Bars3Icon className="h-6 w-6" />
      </Button>

      <TenantSwitcher />

      <div className="hidden flex-1 justify-center sm:flex">
        <SearchBar />
      </div>
      <div className="flex-1 sm:hidden" />

      <div className="flex items-center gap-1">
        <NotificationBell />
        <ThemeToggle />
        <div className="mx-1 h-6 w-px bg-border" aria-hidden="true" />
        <ProfileMenu />
      </div>
    </header>
  );
}
